module.exports = "#styl{\r\n    margin-left:20%;\r\n    margin-right: 20%;\r\n}\r\n#linie{\r\n    float:left;\r\n    margin-left:5%;\r\n    margin-right:5%;\r\n    word-spacing: 20px;\r\n}\r\na{\r\n    color:black;\r\n}\r\na:hover{\r\n    color:red;\r\n    text-decoration: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/stops/details-stop/details-stop.component.css
// module id = ./src/app/stops/details-stop/details-stop.component.css
// module chunks = main